import React from "react";

import SimpleTabs from "~/ui/Tabs";

import styles from "./TranscriptTabs.module.css";

export const TRANSCRIPT_TABS = ["Transcript", "Clips"] as const;
export type TranscriptTabType = (typeof TRANSCRIPT_TABS)[number];

type TranscriptTabsProps = {
	currentTab: TranscriptTabType;
	setCurrentTab: (tab: TranscriptTabType) => void;
};

export default function TranscriptTabs({ currentTab, setCurrentTab }: TranscriptTabsProps) {
	return (
		<SimpleTabs small tab={currentTab} tabs={TRANSCRIPT_TABS} setTab={setCurrentTab} className={styles.tabsWrapper} />
	);
}
